module.exports = __webpack_public_path__ + "static/media/californiaImage.3bf68116.png";